import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TSyainGridLayoutListGetReq,
  TSyainGridLayoutListPostReq,
  TSyainGridLayoutListGetRes,
  TSyainGridLayoutListPostRes,
} from "./TSyainGridLayout"

/**
 * 社員グリッドレイアウトに対するAPIリクエスト用サービス
 *
 * @export
 * @class SyainGridLayoutService
 * @extends {ConnectApi}
 */
export default class SyainGridLayoutService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TSyainGridLayoutListGetReq} params
   * @param {(param: TApiResponse<TSyainGridLayoutListGetRes>) => any} resolve
   * @param {(param: TApiResponse<TSyainGridLayoutListGetRes>) => any} reject
   * @memberof SikutyosonService
   */
  getList = async (
    params: TSyainGridLayoutListGetReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyainGridLayoutListGetRes>> =
        await this.getInner(`/master/syaingridlayout`, params, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体登録
   *
   * @param {TSyainGridLayoutListPostReq} data
   * @param {(param: TApiResponse<TSyainGridLayoutListPostRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TSyainGridLayoutListPostRes>>) => any} reject
   * @memberof KyotenService
   */
  post = async (data: TSyainGridLayoutListPostReq, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyainGridLayoutListPostRes>> =
        await this.postInner(`/master/syaingridlayout`, data, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }
}
